import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import Editbtn from "../Skills/images/circum_edit.svg";
import deletebtn from "../Skills/images/material-symbols-light_delete-outline.svg";
import { baseURL } from "../../config";

const ListTrainingTable = () => {
  const [posts, setPosts] = useState({ trainings: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);
  const [editedTraining, setEditedTraining] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [trainingToDelete, setTrainingToDelete] = useState(null);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/trainings`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.trainings)) {
          setPosts({ trainings: data.trainings });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleDelete = async (trainingId) => {
    try {
      setTrainingToDelete(trainingId);
      setShowDeleteModal(true);
    } catch (error) {
      console.error("Error deleting training:", error);
    }
  };

  const handleSaveEditedTraining = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/trainingupdate?id=${editedTraining.id}`,
        editedTraining
      );
      console.log("Updated Training:", response.data);
      const updatedTrainings = posts.trainings.map((training) => {
        if (training.id === editedTraining.id) {
          return editedTraining;
        }
        return training;
      });
      setPosts({ trainings: updatedTrainings });
      setShowEditModal(false);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("Training not found. Please try again.");
      } else {
        console.error("Error updating Training:", error);
      }
    }
  };

  const confirmDelete = async () => {
    try {
      await axios.get(
        `${baseURL}/deletetraining?id=${trainingToDelete}`
      );
      const updatedTrainings = posts.trainings.filter(
        (training) => training.id !== trainingToDelete
      );
      setPosts({ trainings: updatedTrainings });
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Error deleting Training:", error);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleEdit = (training) => {
    setEditedTraining(training);
    setShowEditModal(true);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.trainings.slice(indexOfFirstPost, indexOfLastPost);

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">LIST TRAINING</h4>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>Course Title</th>
            <th>Duration</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((training, index) => (
            <tr key={index}>
              <td>{training.id}</td>
              <td>{training.trainingname}</td>
              <td>{training.duration}</td>
              <td className="text-center">
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  onClick={() => handleEdit(training)}
                >
                  <img src={Editbtn} alt="Edit" />
                </ReactBootstrap.Button>
                <ReactBootstrap.Button
                  className="bg-transparent border-0"
                  variant="danger"
                  onClick={() => handleDelete(training.id)}
                >
                  <img src={deletebtn} alt="Delete" />
                </ReactBootstrap.Button>
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>
      <ReactBootstrap.Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
      >
        <ReactBootstrap.Modal.Header closeButton>
          <ReactBootstrap.Modal.Title>
            Confirm Deletion
          </ReactBootstrap.Modal.Title>
        </ReactBootstrap.Modal.Header>
        <ReactBootstrap.Modal.Body>
          Are you sure you want to delete this Training?
        </ReactBootstrap.Modal.Body>
        <ReactBootstrap.Modal.Footer>
          <ReactBootstrap.Button
            variant="secondary"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </ReactBootstrap.Button>
          <ReactBootstrap.Button variant="danger" onClick={confirmDelete}>
            Delete
          </ReactBootstrap.Button>
        </ReactBootstrap.Modal.Footer>
      </ReactBootstrap.Modal>
      {showEditModal && editedTraining && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>
              Edit Training
            </ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            <div>
              <label>Training Name :</label>
              <input
                type="text"
                value={editedTraining.trainingname}
                onChange={(e) =>
                  setEditedTraining({
                    ...editedTraining,
                    trainingname: e.target.value,
                  })
                }
              />
            </div>
            <div>
              <label>Duration :</label>
              <input
                type="text"
                value={editedTraining.duration}
                onChange={(e) =>
                  setEditedTraining({
                    ...editedTraining,
                    duration: e.target.value,
                  })
                }
              />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedTraining}
            >
              Update
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}
      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.trainings.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default ListTrainingTable;
